import { render, staticRenderFns } from "./MountedPieceShadow.vue?vue&type=template&id=2a1738d6&scoped=true&"
import script from "./MountedPieceShadow.vue?vue&type=script&lang=js&"
export * from "./MountedPieceShadow.vue?vue&type=script&lang=js&"
import style0 from "./MountedPieceShadow.vue?vue&type=style&index=0&id=2a1738d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1738d6",
  null
  
)

export default component.exports